const carouselItems = [
  {
    title: '《暗潮》登顶周榜 — 悬疑题材再掀热潮',
    desc: '导演李明远暌违三年的回归之作，首周播放量突破5000万，豆瓣开分8.7，被影评人誉为"年度最佳国产悬疑片"。',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20detective%20standing%20in%20rainy%20urban%20alley%20at%20night%2C%20warm%20golden%20streetlight%2C%20noir%20film%20aesthetic%2C%20cinematic%20composition%2C%20dramatic%20shadows%2C%20atmospheric%2C%20no%20text&width=800&height=450&seq=carousel-chunse-01&orientation=landscape',
    tag: '悬疑',
    rank: 1,
  },
  {
    title: '《山河纪》第三季 — 古装史诗续写传奇',
    desc: '原班人马悉数回归，制作规模再升级。前三集放出后口碑持续走高，被誉为"国剧新标杆"。',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20imperial%20palace%20courtyard%20at%20sunset%2C%20warm%20golden%20light%2C%20traditional%20architecture%2C%20misty%20atmosphere%2C%20cinematic%20historical%20drama%20aesthetic%2C%20no%20text&width=800&height=450&seq=carousel-chunse-02&orientation=landscape',
    tag: '古装',
    rank: 2,
  },
  {
    title: '《星际迷航：新纪元》 — 国产科幻新高度',
    desc: '耗资3亿打造，视觉特效全面对标好莱坞。上映两周票房破15亿，开启国产科幻电影新篇章。',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20spaceship%20approaching%20a%20glowing%20nebula%2C%20deep%20space%20background%2C%20warm%20orange%20and%20gold%20cosmic%20colors%2C%20cinematic%20sci-fi%20composition%2C%20epic%20scale%2C%20no%20text&width=800&height=450&seq=carousel-chunse-03&orientation=landscape',
    tag: '科幻',
    rank: 3,
  },
  {
    title: '《青春不散场》 — 校园喜剧温情上线',
    desc: '新生代演员阵容，轻松幽默又不失温情。上线首日即登顶喜剧分类榜，引发全网青春回忆热潮。',
    image: 'https://readdy.ai/api/search-image?query=Warm%20sunlit%20school%20campus%20scene%20with%20young%20students%2C%20golden%20afternoon%20light%2C%20nostalgic%20atmosphere%2C%20soft%20focus%2C%20cinematic%20coming-of-age%20film%20aesthetic%2C%20no%20text&width=800&height=450&seq=carousel-chunse-04&orientation=landscape',
    tag: '喜剧',
    rank: 4,
  },
  {
    title: '《深海迷踪》 — 海洋探险纪录片热映',
    desc: '历时三年拍摄，深入全球七大海洋秘境。真实记录海洋生物奇观，豆瓣9.3分高分纪录片。',
    image: 'https://readdy.ai/api/search-image?query=Deep%20ocean%20underwater%20scene%20with%20sunlight%20rays%20penetrating%20water%20surface%2C%20marine%20life%20silhouettes%2C%20mysterious%20blue-green%20tones%2C%20documentary%20cinematic%20aesthetic%2C%20ethereal%20atmosphere%2C%20no%20text&width=800&height=450&seq=carousel-chunse-05&orientation=landscape',
    tag: '纪录',
    rank: 5,
  },
];

export default function SectionCarousel() {
  return (
    <section id="carousel" className="py-16 md:py-20 px-4 md:px-8 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50 mb-3">
            焦点推荐
          </h2>
          <p className="text-sm text-foreground-400">本周最受关注的热门内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselItems.slice(0, 2).map((item, i) => (
            <div
              key={i}
              className="group bg-background-200/40 rounded-lg border border-background-300/20 overflow-hidden cursor-pointer hover:border-primary-500/30 transition-colors"
            >
              <div className="relative aspect-[16/9] bg-background-300/30 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/70 to-transparent"></div>
                <div className="absolute top-3 left-3 flex items-center gap-2">
                  <span className="px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-bold">
                    TOP {item.rank}
                  </span>
                  <span className="px-2.5 py-1 rounded-full bg-background-950/70 text-xs text-primary-400 backdrop-blur-sm">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-100 group-hover:text-primary-400 transition-colors mb-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-400 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}

          {carouselItems.slice(2).map((item, i) => (
            <div
              key={i + 2}
              className="group bg-background-200/40 rounded-lg border border-background-300/20 overflow-hidden cursor-pointer hover:border-primary-500/30 transition-colors"
            >
              <div className="relative aspect-[16/9] bg-background-300/30 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/70 to-transparent"></div>
                <div className="absolute top-3 left-3 flex items-center gap-2">
                  <span className="px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-bold">
                    TOP {item.rank}
                  </span>
                  <span className="px-2.5 py-1 rounded-full bg-background-950/70 text-xs text-primary-400 backdrop-blur-sm">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-100 group-hover:text-primary-400 transition-colors mb-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-400 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}